const changeTemplate = function (div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;
  oldDiv.text = newDiv;
};


window.onWizzyScriptLoaded = function() {

  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-search-wrapper");
  changeTemplate("wizzy-autocomplete-topproducts");
  changeTemplate("wizzy-autocomplete-suggestions");
  changeTemplate('wizzy-search-empty-results');

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, function(data) {
    if(window.innerWidth < 768) {
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        "dom": ".wizzy-search-popup-container .wizzy-search",
        "type": "text"
      };
    } else {
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        "dom": ".st-desktop-searchbox.st-hidden-sm .wizzy-search-input",
        "type": "text"
      };
    }
    return data;
  });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function(data) {
    // console.log(data," <-- BEFORE_INIT");
    window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
    // window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [];
    if(window.innerWidth < 768) {
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        "dom": ".wizzy-search-popup-container .wizzy-search",
        "type": "text"
      };
    } else {
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        "dom": ".st-desktop-searchbox.st-hidden-sm .wizzy-search-input",
        "type": "text"
      };
    }
    return data;
  });

   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function(data) {
    // console.log(data," <-- BEFORE_SEARCH_EXECUTED");

     // Select the element by ID
      const sectionHeader = document.getElementById('shopify-section-sections--14575226847278__header');
      
      // Check if the element exists
      if (sectionHeader) {
          // Remove the class from the class list
          sectionHeader.classList.remove('shopify-section-header');
      }

      const closeButton = document.querySelector('.wizzy-close-button');
      if (closeButton) {
          closeButton.click();
      }
     
    return data;
  });

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      let x = document.querySelector(".wizzy-body-end-wrapper");
      if(x && typeof data.isForDefault !== 'undefined' && data.isForDefault === true) {
        x.classList.add("wizzy-view-more-hide");
      }else if(x && x.classList.contains("wizzy-view-more-hide")) {
        x.classList.remove("wizzy-view-more-hide");
      }
      return data;
    })

   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function (data) {
    // console.log(data,"AFTER_PRODUCTS_TRANSFORMED");

       data.forEach(product => {
          product.newIn = false;
          product.fullCotton = false;
          product.recycled = false;
          product.twoToThirteen = false;
          product.sevenToThirteen = false;
          // product.soldOutTag = false;
          // if(product.inStock === false) product.soldOutTag=true;
          product.attributes.forEach(attribute => {
            if (attribute.id === "product_tags") {
              //    if (attribute.values.some(value => value.value.includes('Badge1: NEW LAUNCH'))) {
              //   product.plusTag = true;
              // } 
              attribute.values.forEach(tag => {
                  if (tag.value.some(value => value.includes('New_make'))) {
                      product.newIn = true;
                  }
              });
              attribute.values.forEach(tag => {
                  if (tag.value.some(value => value.includes('USP1:100% Cotton'))) {
                      product.fullCotton = true;
                  }
              });
              attribute.values.forEach(tag => {
                  if (tag.value.some(value => value.includes('USP1:RECYCLED'))) {
                      product.recycled = true;
                  }
              });
              attribute.values.forEach(tag => {
                  if (tag.value.some(value => value.includes('USP1:2-13 Years'))) {
                      product.twoToThirteen = true;
                  }
              });
               attribute.values.forEach(tag => {
                  if (tag.value.some(value => value.includes('USP1:7-13 Years'))) {
                      product.sevenToThirteen = true;
                  }
              });

              // if (attribute.values.some(value => value.value.includes('Best-Seller'))) {
              //   product.preLaunchTag = true;
              // }
            }
            });
        });
     
    //////////////////////////////////////////////////////////////////////////
     
     if(data.length == 1) {
        // console.log("Only single product found for this one...");
        setTimeout(function() {
            var selectedFiltersBlock = document.querySelector('.wizzy-selected-filters .wizzy-filters-selected-facets-block');
            if (selectedFiltersBlock) {
                selectedFiltersBlock.style.display = 'block';
                selectedFiltersBlock.style.marginTop = '15px';
            }
        }, 500); 

      }
  
    ////////////////////////////////////////////////////////////

    data.forEach((product) => {
      if(product.attributes) {
        product.attributes.forEach(attribute => {
          if(attribute.id === "product_badge_judgeme") {
            
            const htmlString = attribute.values[0].value[0];
    
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlString;
    
             const innerDiv = tempDiv.querySelector('.jdgm-prev-badge');

            if (innerDiv) {
              const averageRating = innerDiv.getAttribute('data-average-rating');
              const totalReviews = innerDiv.getAttribute('data-number-of-reviews');

              // console.log(averageRating,totalReviews)
    
              product.avgRatings = parseFloat(averageRating); 
              product.totalReviews = parseInt(totalReviews);
            }
            
          }
        });
      }
    });

     //////////////////////////////////////////////////////////////////

     data.forEach((product) => {
      if(product.attributes) {
        product.attributes.forEach(attribute => {
          if(attribute.id === "product_product_meta_secondary_text_my_fields") {
            product.secondTitle = attribute.values[0].value[0];
          }
        });
      }
    });

   
    return data;    
  });
  
}



// MUTATION OBSERVER 1 //////////////////////////////////
function isDesktopWidth() {
    return window.innerWidth >= 1024; 
}

function setPositions() {
    if (isDesktopWidth()) {
        const targetElement = document.querySelector('.wizzy-overlay-opened.wizzy-filters-overlay .wizzy-search-wrapper.has-facets-in-drawer.facets-drawer-on-left .wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-search-filters-left-wrapper');

        const element = document.querySelector('.wizzy-search-wrapper .wizzy-filters-desktop-entry');

        const rect = element.getBoundingClientRect();
        const topPosition = rect.top;
        const leftPosition = rect.left;

        targetElement.style.top = `${topPosition+40}px`;
        targetElement.style.left = `${leftPosition+0}px`;
    }
}

const observerConfig = { attributes: true, subtree: true, attributeFilter: ['class'] };

const observerCallback = function(mutationsList, observer) {
    mutationsList.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (document.body.classList.contains('wizzy-filters-overlay') && isDesktopWidth()) {
                setPositions();
            }
        }
    });
};

const observer = new MutationObserver(observerCallback);

observer.observe(document.body, observerConfig);

// MUTATION OBSERVER 2 //////////////////////////////////


// document.documentElement.clientWidth < 768) {
//     let checkClosestWizzyForm2 = function(element) {
//         for (; element; ) {
//             if (element.id === "wizzySearchForm-Mobile")
//                 return !0;
//             element = element.parentElement
//         }
//         return !1
//     };
//     var checkClosestWizzyForm = checkClosestWizzyForm2;
//     let isAutocompleteMutationConfigured = !1;
//     const setMutationToAutocomplete = (id,options={})=>{
//         if (isAutocompleteMutationConfigured)
//             return;
//         let mutationHandler = target=>{
//             let targetEle = target;
//             if (targetEle.hasChildNodes()) {
//                 var x = targetEle.querySelector(".wizzy-autocomplete-wrapper");
//                 if (x != null)
//                     isVisible = window.getComputedStyle(targetEle.querySelector(".wizzy-autocomplete-wrapper")).display === "flex";
//                 else
//                     return
//             } else if (targetEle.classList.contains("wizzy-autocomplete-wrapper"))
//                 isVisible = window.getComputedStyle(targetEle.display) == "flex";
//             else
//                 return;
//             isVisible ? document.body.classList.add("wizzy-autocomplete-visible") : document.body.classList.remove("wizzy-autocomplete-visible")
//         }
//         ;
//         new MutationObserver(function(mutations) {
//             mutations.forEach(function(mutationRecord) {
//                 switch (mutationRecord.type) {
//                 case "childList":
//                     mutationHandler(mutationRecord.target);
//                     break;
//                 case "subtree":
//                     break;
//                 default:
//                 }
//             })
//         }
//         ).observe(document.getElementById(id), options),
//         isAutocompleteMutationConfigured = !0
//     }
//     ;
//     document.querySelector(".wizzy-body-end-wrapper").setAttribute("id", "wizzy-body-end-wrapper"),
//     setMutationToAutocomplete("wizzy-body-end-wrapper", {
//         subtree: !0,
//         childList: !0,
//         attributes: !0
//     }),
//     document.querySelector(".header-wrapper").addEventListener("click", function(e) {
//         var x = document.querySelector("body");
//         checkClosestWizzyForm2(e.target) || x.classList.contains("wizzy-autocomplete-visible") && x.classList.remove("wizzy-autocomplete-visible")
//     })
// }


// MUTATION OBSERVER 2 //////////////////////////////////

function addClassToBody(className) {
  document.body.classList.add(className);
}

function removeClassFromBody(className) {
  document.body.classList.remove(className);
}

function handleClassChange(mutationsList, observer) {
  mutationsList.forEach(mutation => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class' && window.location.pathname === '/pages/search') {
      const headerSection = document.querySelector('#shopify-section-sections--14575226847278__header');
      if (headerSection) {
        const hasStickyClass = headerSection.classList.contains('shopify-section-header-sticky');
        if (hasStickyClass) {
          addClassToBody('wizzy-custom');
          removeClassFromBody('wiz-custom');
        } else {
          removeClassFromBody('wizzy-custom');
           addClassToBody('wiz-custom');
        }
      }
    }
  });
}

const headerSection = document.querySelector('#shopify-section-sections--14575226847278__header');

if (headerSection) {
  const observer = new MutationObserver(handleClassChange);
  observer.observe(headerSection, { attributes: true });
}

//////////////////////////////////////////////////////////////////////////

const searchInput = document.querySelector('.st-mobile-searchbox .wizzy-search-input');

if (searchInput) {
  searchInput.addEventListener('focus', function() {
    addClassToBody('wizzy-overflow');
  });

  searchInput.addEventListener('blur', function() {
    removeClassFromBody('wizzy-overflow');
  });
}

/////////////////////////////////

function isMobileView() {
  return window.innerWidth <= 768; 
}

if (isMobileView()) {
  
  const searchInputSecond = document.querySelector('.st-mobile-searchbox .st-search-bar input.wizzy-search-input');

  if (searchInputSecond) {
    searchInputSecond.addEventListener('focus', function() {
      addClassToBody('wiz-overflow');
    });
  
    searchInputSecond.addEventListener('blur', function() {
      removeClassFromBody('wizz-overflow');
    });
  }
  
}











/////////////////////////////////


const searchMobile = document.getElementById('search-mobile');
const iconContainer = document.querySelector('.icon-container');
const searchContainer = document.querySelector('.wizzy-search');

function handleIconContainerClick() {
    if (iconContainer) {
        iconContainer.click();
    }
    if (searchContainer) {
        setTimeout(function() {
            searchContainer.click();
            searchContainer.focus();
        }, 100); 
    }

}

if (searchMobile) {
    searchMobile.addEventListener('focus', handleIconContainerClick);
    searchMobile.addEventListener('click', handleIconContainerClick);
}



// const searchMobile = document.getElementById('search-mobile');
// const iconContainer = document.querySelector('.icon-container');

// function handleIconContainerClick() {
//     if (iconContainer) {
//         iconContainer.click();
//     }
//     const searchContainer = document.querySelector('.wizzy-search-popup-container');
//     if (searchContainer) {
//         setTimeout(function() {
//             searchContainer.click();
//             searchContainer.focus();
//         }, 100);
//     }
// }

// function setupEventListeners() {
//     if (searchMobile) {
//         searchMobile.addEventListener('focus', handleIconContainerClick);
//         searchMobile.addEventListener('click', handleIconContainerClick);
//     }
// }

// // Observe the document body for changes
// const observerTwo = new MutationObserver(function(mutationsList) {
//     for (const mutation of mutationsList) {
//         if (mutation.type === 'childList') {
//             // Check if the .wizzy-search-popup-container is now in the DOM
//             if (document.querySelector('.wizzy-search-popup-container')) {
//                 setupEventListeners();
//                 // observerTwo.disconnect(); // Stop observing once the element is found
//             }
//         }
//     }
// });

// // Start observing the document body for changes
// observerTwo.observe(document.body, { childList: true, subtree: true });

///////////////////////////////////////////////


// setTimeout(() => {
//     const cartIcon = document.querySelector('.mini-cart__header-inner .header__icon.header__icon--cart');
//     const closeButton = document.querySelector('.wizzy-close-button');

//     if (cartIcon && closeButton) {
//       cartIcon.addEventListener('click', () => {
//         closeButton.click();
//       });
//     }
//   }, 1000);


//////////////////////////////////////////////////


const runCode = () => {
  setTimeout(() => {
  const cartIcon = document.querySelector('.mini-cart__header-inner .header__icon.header__icon--cart');
  const closeButton = document.querySelector('.wizzy-close-button');

  if (cartIcon && closeButton) {
    cartIcon.addEventListener('click', () => {
      closeButton.click();
    });
  }
  }, 300);
};

const observerNew = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      const body = document.body;
      if (body.classList.contains('mini-cart--open')) {
        // console.log("wizzy mutation working....");
        runCode();
        // observerNew.disconnect();
        break;
      }
    }
  }
});

observerNew.observe(document.body, { attributes: true });


///////////////////////////////////////////////////////////////////////////////



const headerElement = document.querySelector('#shopify-section-sections--14575226847278__header');

if (headerElement) {
    const observerHeader = new MutationObserver((mutationsList) => {
        mutationsList.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const currentClasses = headerElement.classList;
                
                if (currentClasses.contains('shopify-section-header-hidden')) {
                    document.body.classList.remove('wizzy-sticky');
                } else {
                    document.body.classList.add('wizzy-sticky');
                }
            }
        });
    });

    observerHeader.observe(headerElement, {
        attributes: true, // Watch for attribute changes
        attributeFilter: ['class'], // Only watch the 'class' attribute
    });

}
